export default "__VITE_ASSET__93474ead__"